<template>
    <div class="step-container">
     <span v-bind:class="{stepActive: isActiveCart}">장바구니</span>
     <span v-bind:class="{stepActive: isActivePlan}">체험 플랜</span>
     <span v-bind:class="{stepActive: isActiveCustomer}">배송지 입력</span>
     <!-- <span v-bind:class="{stepActive: isActiveCard}">결제 정보</span> -->
     <span v-bind:class="{stepActive: isActiveComplete}">신청 확인</span>
    </div>
</template>

<script>
export default {
  name: 'step',
  props: ['isActiveCart', 'isActivePlan', 'isActiveCustomer', 'isActiveCard', 'isActiveComplete', 'isShow']
}
</script>

<style scoped>
  .step-container {
    padding: 10px 10px 0px 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: #ffffff;
    font-size: 10pt;
    color: rgb(133, 136, 139);
  }
  .step-container span {
    padding: 5px;
  }
  @media (max-width: 320px) {
    .step-container {
      justify-content: space-between;
    }
    .step-container span {
      padding: 0px;
    }
  }
  .stepActive {
    border-bottom: 3px solid #3d4953;
    color: rgb(61, 73, 83);
  }

</style>



// WEBPACK FOOTER //
// src/components/apply/Step.vue